import { render } from "./EditTeamSocials.vue?vue&type=template&id=5831389f"
import script from "./EditTeamSocials.vue?vue&type=script&lang=js"
export * from "./EditTeamSocials.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__